@if (!child) {
  <div
        [ngClass]="{'hemro-horizontal-navigation-menu-active': trigger.menuOpen || active,
                 'hemro-horizontal-navigation-menu-active-forced': item.active}"
    [matMenuTriggerFor]="matMenu"
    (onMenuOpen)="triggerChangeDetection()"
    (onMenuClose)="triggerChangeDetection()"
    #trigger="matMenuTrigger">
    <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
  </div>
}

<mat-menu
  class="hemro-horizontal-navigation-menu-panel"
  [overlapTrigger]="false"
  #matMenu="matMenu">

  @for (item of item.children; track trackByFn($index, item)) {
    <!-- Skip the hidden items -->
    @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
      <!-- Basic -->
      @if (item.type === 'basic') {
        <div
          class="hemro-horizontal-navigation-menu-item"
          [disabled]="item.disabled"
          mat-menu-item>
          <hemro-horizontal-navigation-basic-item
            [item]="item"
          [name]="name"></hemro-horizontal-navigation-basic-item>
        </div>
      }
      <!-- Branch: aside, collapsable, group -->
      @if (item.type === 'aside' || item.type === 'collapsable' || item.type === 'group') {
        <div
          class="hemro-horizontal-navigation-menu-item"
          [disabled]="item.disabled"
          [matMenuTriggerFor]="branch.matMenu"
          mat-menu-item>
          <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
          <hemro-horizontal-navigation-branch-item
            [child]="true"
            [item]="item"
            [name]="name"
          #branch></hemro-horizontal-navigation-branch-item>
        </div>
      }
      <!-- Divider -->
      @if (item.type === 'divider') {
        <div
          class="hemro-horizontal-navigation-menu-item"
          mat-menu-item>
          <hemro-horizontal-navigation-divider-item
            [item]="item"
          [name]="name"></hemro-horizontal-navigation-divider-item>
        </div>
      }
    }
  }

</mat-menu>

<!-- Item template -->
<ng-template
  let-item
  #itemTemplate>

  <div
    class="hemro-horizontal-navigation-item-wrapper"
    [class.hemro-horizontal-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="item.classes?.wrapper">

    <div
      class="hemro-horizontal-navigation-item"
            [ngClass]="{'hemro-horizontal-navigation-item-disabled': item.disabled,
                         'hemro-horizontal-navigation-item-active-forced': item.active}"
      [matTooltip]="item.tooltip || ''">

      <!-- Icon -->
      @if (item.icon) {
        <mat-icon
          class="hemro-horizontal-navigation-item-icon"
          [ngClass]="item.classes?.icon"
        [svgIcon]="item.icon"></mat-icon>
      }

      <!-- Title & Subtitle -->
      <div class="hemro-horizontal-navigation-item-title-wrapper">
        <div class="hemro-horizontal-navigation-item-title">
          <span [ngClass]="item.classes?.title">
            {{item.title | transloco}}
          </span>
        </div>
        @if (item.subtitle) {
          <div class="hemro-horizontal-navigation-item-subtitle text-hint">
            <span [ngClass]="item.classes?.subtitle">
              {{item.subtitle | transloco}}
            </span>
          </div>
        }
      </div>

      <!-- Badge -->
      @if (item.badge) {
        <div class="hemro-horizontal-navigation-item-badge">
          <div
            class="hemro-horizontal-navigation-item-badge-content"
            [ngClass]="item.badge.classes">
            {{item.badge.title}}
          </div>
        </div>
      }
    </div>
  </div>

</ng-template>
